import React, { useEffect, useState } from "react";
import LoginHeaderOperational from "./LoginHeaderOperational";
import Sidebar_Progress from "../layouts/Operational_Sidebar_Progress.component";
import { API_URL } from "../../constant/API_Settings";
import GstFilingReportPanel from "./GstFilingReportPanel";
import { isOwnerRole } from "../../utils/ownerRole";

/**
 * Statutory filing reports — GST, TDS, and other Indian tax filing documents (owner-only).
 */
const StatutoryFilingReports = (props) => {
  const [access, setAccess] = useState({ allowed: false, message: "Checking access…" });
  const [activeTab, setActiveTab] = useState("gst");

  useEffect(() => {
    const headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("AUTH_TOKEN") + "",
      Accept: "application/json",
    };

    Promise.all([
      fetch(`${API_URL}/check_url`, {
        method: "post",
        headers,
        body: JSON.stringify({ pathurl: window.location.pathname }),
      }).then((r) => r.json()),
      fetch(`${API_URL}/is_owner`, { method: "get", headers }).then((r) => r.json()),
    ])
      .then(([urlData, roleName]) => {
        const isOwner = isOwnerRole(roleName);
        if (!isOwner) {
          setAccess({
            allowed: false,
            message: "Statutory filing reports are available to pump owners only.",
          });
          return;
        }
        if (urlData.allowurl != 1) {
          setAccess({
            allowed: false,
            message: "This screen is not available for your current setup.",
          });
          return;
        }
        setAccess({ allowed: true, message: "" });
      })
      .catch(() => {
        setAccess({
          allowed: false,
          message: "Unable to verify access. Please try again.",
        });
      });
  }, []);

  return (
    <div className="main-container page-wrap statutory-filing-page">
      <div className="d-md-flex">
        <Sidebar_Progress props={props} progress={29} operation={4} op={3} />
        <div className="content-area">
          <LoginHeaderOperational props={props} page_title="" />
          {!access.allowed ? (
            <div className="form-wrap mt-5">
              <div className="text-center">{access.message}</div>
            </div>
          ) : (
            <div className="container pb-3">
              <div className="row justify-content-center mt-3 form-container">
                <div className="col-md-12">
                  <div className="dash-card owner-chart-card p-3 mb-3">
                    <h4 className="mb-1">Statutory filing reports</h4>
                    <p className="text-muted small mb-0">
                      Download calculations and summaries for monthly / quarterly GST, TDS, and other
                      Indian tax filings.
                    </p>
                  </div>

                  <ul className="nav nav-tabs mb-3 statutory-filing-tabs">
                    <li className="nav-item">
                      <button
                        type="button"
                        className={`nav-link ${activeTab === "gst" ? "active" : ""}`}
                        onClick={() => setActiveTab("gst")}
                      >
                        GST filing
                      </button>
                    </li>
                    <li className="nav-item">
                      <button type="button" className="nav-link disabled" disabled title="Coming soon">
                        TDS
                      </button>
                    </li>
                    <li className="nav-item">
                      <button type="button" className="nav-link disabled" disabled title="Coming soon">
                        Other returns
                      </button>
                    </li>
                  </ul>

                  <div className="dash-card owner-chart-card p-3">
                    {activeTab === "gst" ? <GstFilingReportPanel /> : null}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default StatutoryFilingReports;
